import { axios } from 'libs';

const resource = '/tipos-pessoa-documento';

export const findAll = () => {
  return axios.get(resource);
};
